import { useCallback } from 'react';
import { useSafeLocalStorage } from '@gonfalon/observability-ui/hooks/useSafeLocalStorage';

import type { RepoSelection, RepoSelectionStorage } from './useGitHubRepoSelection';

/** Vega's surfaces deliberately share one selection, so picking repos in one carries to the other. */
export const VEGA_REPO_SELECTION_STORAGE_KEY = 'vega-selected-repositories';

/**
 * Browser-local repo selection, for surfaces with nothing server-side to persist it on.
 *
 * Pass the result as `storage` to `useGitHubRepoSelection`.
 */
export function useLocalStorageRepoSelection(
  key: string = VEGA_REPO_SELECTION_STORAGE_KEY,
  initial: RepoSelection = [],
): RepoSelectionStorage {
  const [value, setValue] = useSafeLocalStorage<RepoSelection>(key, initial);
  const onChange = useCallback((next: string[]) => setValue(next), [setValue]);

  return { value, onChange };
}
